import React from 'react'

const SchedulerHandle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <circle cx="6" cy="6" r="5" fill="white" stroke="#E8EBED" stroke-width="2"/>
  <g filter="url(#filter0_i_1146_134536)">
    <path d="M3.6001 8.09961V3.89961C3.6001 3.73392 3.73441 3.59961 3.9001 3.59961C4.06578 3.59961 4.2001 3.73392 4.2001 3.89961V8.09961C4.2001 8.2653 4.06578 8.39961 3.9001 8.39961C3.73441 8.39961 3.6001 8.2653 3.6001 8.09961Z" fill="white"/>
    <path d="M6 8.09961V3.89961C6 3.73392 6.13431 3.59961 6.3 3.59961C6.46569 3.59961 6.6 3.73392 6.6 3.89961V8.09961C6.6 8.2653 6.46569 8.39961 6.3 8.39961C6.13431 8.39961 6 8.2653 6 8.09961Z" fill="white"/>
    <path d="M8.3999 8.09961V3.89961C8.3999 3.73392 8.53422 3.59961 8.6999 3.59961C8.86559 3.59961 8.9999 3.73392 8.9999 3.89961V8.09961C8.9999 8.2653 8.86559 8.39961 8.6999 8.39961C8.53422 8.39961 8.3999 8.2653 8.3999 8.09961Z" fill="white"/>
  </g>
  <defs>
    <filter id="filter0_i_1146_134536" x="3.6001" y="3.59961" width="6.3999" height="4.7998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1"/>
      <feGaussianBlur stdDeviation="1"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.561749 0 0 0 0 0.557845 0 0 0 0 0.557845 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1146_134536"/>
    </filter>
  </defs>
</svg>
)

export default SchedulerHandle;
